// extracted by mini-css-extract-plugin
module.exports = {"connectWallet":"ConnectWallet_connectWallet__2Jyh0","actions":"ConnectWallet_actions__3-_zl","actionButton":"ConnectWallet_actionButton__1I15O","text":"ConnectWallet_text__1Lc7O"};